import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import LoadingState from '../shared/LoadingState';
import EmptyState from '../shared/EmptyState';
import '../superadmin/DistrictsList.css';

const ReturningStudentList = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/students/my-students');
      setStudents(response.data);
    } catch (error) {
      console.error('Failed to fetch students:', error);
      setError('Failed to load students');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingState message="Loading students..." fullScreen />;
  }

  if (error) {
    return (
      <div className="districts-list">
        <div className="page-header">
          <h2>Returning Student Forms</h2>
        </div>
        <div className="error-message">{error}</div>
      </div>
    );
  }

  return (
    <div className="districts-list">
      <div className="page-header">
        <h2>Returning Student Forms</h2>
        <p>Select a student to update their information for the new school year.</p>
      </div>

      {students.length === 0 ? (
        <EmptyState
          icon="📝"
          title="No Students Found"
          message="You don't have any students registered yet. Add a student to get started with returning student forms."
          action={<Link to="/parent/student-intake/new" className="btn-primary">Add Student</Link>}
        />
      ) : (
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>Name (Last, First)</th>
                <th>Grade</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {students.map(student => (
                <tr key={student?.id}>
                  <td>{student?.last_name || ''}, {student?.first_name || ''}</td>
                  <td>{student?.grade || '-'}</td>
                  <td className="actions">
                    <Link
                      to={`/parent/returning-student/${student?.id}`}
                      className="btn-primary"
                    >
                      Returning Student Forms
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ReturningStudentList;


